import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import VehicleTypeList from "./VehicleTypeList";
import PageInfoTitle from "../../../components/pageTitle/PageInfoTitle";
import VehicleTypeDetails from "./VehicleTypeDetails";
import ManageVehicleType from "./ManageVehicleType";
import { FUEL_FORM } from "./vehicleAllFields";
import FormField from "../../../components/common/FormField";
import { useDispatch } from "react-redux";
import {
  addFuelDetails,
  deleteVehicleType,
  deleteVehicleTypeSuccess,
  getFuelDetails,
  setAddFuelDetails,
  setUpdateVehicleTypeResponse,
} from "../../../store/reducers/vehicleSlice";
import { useSelector } from "react-redux";
import CustomButton from "../../../components/common/button/CustomButton";
import DeleteAlert from "../../../components/common/DeleteAlert";
const VehicleTypeSetting = () => {
  const [openVehicleType, setOpenVehicleType] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState<string | null>(null);
  const [selectedId, setSelectedId] = useState<any | null>(null); // track selected
  const [deleteModelShow, setDeleteModelShow] = useState(false);
  const dispatch = useDispatch();
  const {
    fuelDetails,
    isAddFuelDetails,
    isDeleteVehicleTypeResponse,
    isAddVehicleTypeResponse,
  } = useSelector((state: any) => state.vehicle);
  const [value, setValue] = useState("0");
  const [fuelData, setFuelData] = useState<any>({
    petrol_rate: null,
    diesel_rate: null,
    electric_rate: null,
  });

  useEffect(() => {
    if (fuelDetails) {
      setFuelData({
        ...fuelDetails,
        petrol_rate: fuelDetails?.petrol_rate || null,
        diesel_rate: fuelDetails?.diesel_rate || null,
        electric_rate: fuelDetails?.electric_rate || null,
      });
    }
  }, [fuelDetails]);

  useEffect(() => {
    dispatch(getFuelDetails());
    dispatch(setAddFuelDetails(false));
  }, [dispatch, isAddFuelDetails]);
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  const handleEditVehicle = (id: any | null) => {
    setOpenVehicleType(true);
    setSelectedRowId(id);
  };

  const handleSubmit = (event: React.MouseEvent<HTMLButtonElement>) => {
    console.log("Submitting fuel data:", fuelData);
    event.preventDefault();
    dispatch(addFuelDetails(fuelData));
  };

  const handleDeleteAlert = (id: any | null) => {
    setDeleteModelShow(true);
    setSelectedRowId(id);
  };

  const handleDelete = () => {
    dispatch(deleteVehicleType(selectedId));
  };

  useEffect(() => {
    if (isAddVehicleTypeResponse) {
      setOpenVehicleType(false);
      setDeleteModelShow(false);
      setSelectedRowId(null);
      dispatch(setUpdateVehicleTypeResponse(false));
    }
  }, [isAddVehicleTypeResponse]);

  useEffect(() => {
    if (isDeleteVehicleTypeResponse) {
      setOpenVehicleType(false);
      setDeleteModelShow(false);
      setSelectedRowId(null);
      setSelectedId(null);
      dispatch(deleteVehicleTypeSuccess(false));
    }
  }, [isDeleteVehicleTypeResponse]);

  return (
    <>
      {deleteModelShow && (
        <DeleteAlert
          alertModalShow={deleteModelShow}
          onConfirm={() => {
            handleDelete();
          }}
          message={"Are you sure you want to delete this vehicle type?"}
          setAlertModelShow={setDeleteModelShow}
        />
      )}
      {openVehicleType && (
        <ManageVehicleType
          open={openVehicleType}
          onHide={() => setOpenVehicleType(false)}
          title="Edit Vehicle"
          selectedVehicle={selectedRowId}
          action="edit"
          setSelectedVehicle={setSelectedRowId}
        />
      )}
      <Tabs
        value={value}
        onChange={handleChange}
        textColor="secondary"
        indicatorColor="secondary"
        aria-label="secondary tabs example"
        variant="standard"
        sx={{
          background: "#fff",
          fontSize: "14px",
          fontWeight: 600,
          marginBottom: "16px",
        }}
      >
        <Tab value="0" label="Vehicle Type" />
        <Tab value="1" label="Fuel Details" />
      </Tabs>
      {value === "0" && (
        <Grid
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 12 }}
          sx={{ height: "100vh" }}
        >
          <Grid
            item
            xs={12}
            md={3}
            sx={{ paddingLeft: "0px !important", paddingTop: "0px !important" }}
          >
            <Box
              sx={{
                bgcolor: "#fff",
                height: { xs: "auto", md: "100vh" },
                // border: "1px solid #d1cfcf",
                // borderRadius: "5px",
                padding: "4px",
              }}
            >
              <VehicleTypeList
                setSelectedId={setSelectedId}
                selectedId={selectedId}
              />
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={9}
            sx={{
              paddingLeft: "16px !important",
              paddingTop: "0px !important",
            }}
          >
            <Container
              maxWidth="lg"
              sx={{
                paddingLeft: "0px !important",
                paddingRight: "0px !important",
                background: "#fff",
              }}
            >
              <Box
                sx={{
                  height: { xs: "auto", md: "100vh" },
                  // border: "1px solid #d1cfcf",
                  // borderRadius: "5px",
                  paddingLeft: "0px !important",
                  paddingRight: "0px !important",
                  // padding: "0px 16px",
                  overflow: "scroll",
                }}
              >
                <Box
                  sx={{
                    position: "sticky",
                    top: 0,
                    bgcolor: "#fff",
                    zIndex: 1,
                    border: "1px solid #C4CDD5",
                  }}
                >
                  <PageInfoTitle
                    title="Vehicle Type Details"
                    // button={selectedId ? "Edit" : undefined}
                    // onClick={() => handleEditVehicle(selectedId)}
                  />
                </Box>
                <Box
                  sx={{
                    bgcolor: "#fff",
                    height: { xs: "auto" },
                    //   border: "1px solid #d1cfcf",
                    borderRadius: "5px",
                    overflow: "hidden",
                    // padding: "10px",
                    padding: "10px 4px !important",
                  }}
                >
                  {selectedId ? (
                    <VehicleTypeDetails
                      selectedId={selectedId}
                      onEditClick={() => handleEditVehicle(selectedId)}
                      onDeleteClick={() => handleDeleteAlert(selectedId)}
                    />
                  ) : (
                    <center>
                      <Typography sx={{ color: "#4A4A4A" }}>
                        No Record Found!
                      </Typography>
                    </center>
                  )}
                </Box>
              </Box>
            </Container>
          </Grid>
        </Grid>
      )}
      {value === "1" && (
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 12 }}>
          <Grid
            item
            xs={12}
            md={12}
            sx={{
              paddingLeft: "16px !important",
              paddingTop: "16px !important",
              paddingBottom: "16px !important",
              background: "#E5F4F1",
              border: "1px solid #C4CDD5",
            }}
          >
            <Container
              maxWidth="lg"
              sx={{
                paddingLeft: "0px !important",
                paddingRight: "0px !important",
              }}
            >
              <Grid container spacing={1}>
                {FUEL_FORM?.map((field, i) => {
                  let dynamicField = { ...field };
                  return (
                    <>
                      <FormField
                        key={field.id}
                        onPaste={(e: any) =>
                          field?.id === "name" || field?.id === "email"
                            ? ""
                            : e.preventDefault()
                        }
                        onKeyDown={(event: any) => {
                          if (
                            [8, 9, 37, 38, 39, 40, 18, 17].includes(
                              event.keyCode,
                            ) ||
                            event.ctrlKey
                          )
                            return event;
                          if (
                            field?.patternAllowed &&
                            !field?.patternAllowed.test(event.key)
                          ) {
                            event.preventDefault();
                          } else if (
                            field?.patternAllowed &&
                            !field?.patternAllowed.test(
                              event.target.value + event.key,
                            )
                          ) {
                            event.preventDefault();
                          }
                        }}
                        {...{
                          ...dynamicField,
                          value: fuelData ? fuelData[dynamicField.id] : "",
                          prefixIcon: "£",
                          inSingleGridForm: true,
                          minDate:
                            field.id === "movingOnDate"
                              ? new Date()
                              : undefined,
                          // maxDate:
                          //   field.id === "followUpDate"
                          //     ? newLeadLocal?.movingOnDate &&
                          //       dayjs(newLeadLocal.movingOnDate)
                          //         .toDate()
                          //     : undefined,
                          variant: "outlined",
                          onChange: (e: any) =>
                            setFuelData({
                              ...fuelData,
                              [field.id]: e.target.value,
                            }),

                          isNonMarginTop: true,
                          GridFieldStyle: {
                            paddingLeft:
                              field.type === "daterangebothvalue" ||
                              field.type === "date"
                                ? "8px !important"
                                : "auto",
                          },
                          InputProps: {
                            ...(field?.inputProps && field?.inputProps),
                            sx:
                              field.type === "text" || field.type === "password"
                                ? { height: "36px" }
                                : { padding: "10px 4px", height: "36px" },
                          },
                          // error: error && error[field.id],
                        }}
                      />
                    </>
                  );
                })}
                <Grid
                  item
                  xs={3}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    paddingRight: "16px !important",
                    marginTop: "10px",
                  }}
                >
                  <CustomButton
                    variant="contained"
                    onClick={handleSubmit}
                    title="Save"
                    style={{ padding: "10px 56px", height: "36px" }}
                  />
                </Grid>
              </Grid>
            </Container>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default VehicleTypeSetting;
